// 検索結果の並び替え ZETA提供データ
const sortType = [
  {
    value: 0,
    string: 'CheapestFirst',
    ja: '安い順',
  },
  {
    value: 1,
    string: 'HighestFirst',
    ja: '高い順',
  },
]

export default sortType
